/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Privacy_Modal from "../Component/Privacy_Modal";
import theme, { Content_Text } from "../Component/theme";
import ic_red_dot from "../image/ic_red_dot.png";
import Footer_Live from "./Footer_Live";
import Header_Live from "./Header_Live";
import Side_Live from "./Side_Live";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;

const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;
const NameInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 600px;
  margin-top: 10px;
  padding: 8px 5px;
  @media (max-width: 800px) {
    width: 98%;
  }
`;

const PhoneInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 10%;
  margin-top: 10px;
  padding: 8px 5px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const PayList = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

const PaySelect = styled.div`
  display: flex;
  padding: 5px 0px;
  align-items: center;
`;

const MemoInput = styled.textarea`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  height: 100px;
  width: 96%;
  margin-top: 10px;
  padding: 10px;
  resize: none;
`;
const CheckBox = styled.input`
  appearance: none;
  border: 1.5px solid ${theme.colors.barGray};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  margin-right: 10px;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px; /* 내부 원의 크기 */
    height: 12px; /* 내부 원의 크기 */
    background-color: ${theme.colors.fontBlue2};
    border-radius: 100px;
  }
`;

const CheckBox2 = styled.input`
  appearance: none;
  border: 1.5px solid ${theme.colors.barGray};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  margin-right: 10px;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: ${theme.colors.fontBlue2};
    border-radius: 100px;
  }
`;
const AboutFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  padding-top: 22px;
`;
const Button = styled.button`
  background-color: ${(props) =>
    props.disabled ? theme.colors.barDarkGray : "black"};
  color: white;
  padding: 10px 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  border-width: 0px;
  border-radius: 8px;
  text-align: center;
  text-justify: center;
  transition: background-color 0.3s ease;
`;

function About_Live() {
  const [name, set_Name] = useState("");
  const [phone_f, set_Phone_f] = useState("");
  const [phone_s, set_Phone_s] = useState("");
  const [phone_t, set_Phone_t] = useState("");
  const [email, set_Email] = useState("");
  const [memo, set_Memo] = useState("");
  const [pay, set_Pay] = useState(0);
  const [pay_list, set_Pay_liset] = useState([
    "2,000만원 이하",
    "2,000 ~ 3,000만원",
    "3,000 ~ 5,000만원",
    "5,000만원 이상",
  ]);
  const [check, set_Check] = useState(false);
  const [modal, set_Modal] = useState(false);
  const [reference, set_Reference] = useState("");
  const [loading, set_Loading] = useState(false);

  const name_set = (event) => {
    set_Name(event.target.value);
  };
  const phone_f_set = (event) => {
    if (event.target.value.length < 4) {
      set_Phone_f(event.target.value);
    }
  };
  const phone_s_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_s(event.target.value);
    }
  };
  const phone_t_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_t(event.target.value);
    }
  };
  const email_set = (event) => {
    set_Email(event.target.value);
  };
  const memo_set = (event) => {
    set_Memo(event.target.value);
  };
  const pay_set = (num) => {
    set_Pay(num);
  };
  const open_Modal = () => {
    set_Modal(true);
  };
  const close_Modal = () => {
    set_Modal(false);
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // 사이즈 체크

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const send_mail = () => {
    if (!check) {
      alert("개인정보 수집 및 이용 동의에 동의해주세요.");
    } else if (
      name === "" ||
      phone_f === "" ||
      phone_s === "" ||
      phone_t === "" ||
      email === ""
    ) {
      alert("필수 입력 항목을 입력해주세요.");
    } else if (
      (email !== "" && !email.includes("@")) ||
      (email !== "" && !email.includes("."))
    ) {
      alert("이메일 주소를 확인해주세요.");
    } else {
      set_Loading(true);
      axios
        .post(
          "http://linkfms.kr/FMS/outsourcing_system.php",
          {
            name: name,
            phone: phone_f + "-" + phone_s + "-" + phone_t,
            user_email: email,
            service_type: "라이브커머스",
            project_budget: pay_list[pay],
            reference: reference,
            project_content: memo,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(function () {
          // alert(response.data);
          alert("문의완료. 24시간내로 연락드릴게요!");
          set_Loading(false);
        })
        .catch(function () {
          // console.log(error);
        });
    }
  };

  useEffect(() => {
    // STEP 1: wcslog.js 스크립트가 이미 로드된 상태여야 함
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//wcs.naver.net/wcslog.js";
    document.body.appendChild(script);

    script.onload = () => {
      // STEP 2: _nasa 변수에 전환 추적 정보를 담음
      var _nasa = {};
      if (window.wcs) {
        _nasa["cnv"] = window.wcs.cnv("4", "1"); // 결제 금액 변수를 실제 값으로 대체
        window.wcs_do(_nasa);
      }
    };

    // Clean up the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Live page="제작문의" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Side_Live />
        <Main_div style={{ paddingBottom: windowSize.width < 800 ? 0 : 20 }}>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                제작문의
              </Content_Text>
              {windowSize.width < 800 ? (
                <>
                  <Content_Text style={{ marginTop: 5 }}>
                    기역기역 주식회사만의 제작 경험과 노하우로
                  </Content_Text>
                  <Content_Text style={{ marginTop: 3 }}>
                    최고의 라이브커머스 웹 사이트를 제작해드립니다.
                  </Content_Text>
                </>
              ) : (
                <Content_Text style={{ marginTop: 5 }}>
                  기역기역 주식회사만의 제작 경험과 노하우로 최고의 라이브커머스
                  웹 사이트를 제작해드립니다.
                </Content_Text>
              )}
            </Main_Content>
          </Main_init_div>
        </Main_div>

        <Main_div style={{ paddingBottom: 200 }}>
          <Main_init_div style={{ paddingTop: 20 }}>
            <Main_Content $left style={{ maxWidth: 600 }}>
              <TitleDiv>
                <Content_Text $xbold $xsmall>
                  이름
                </Content_Text>
                <img
                  style={{ height: 5, marginLeft: 5 }}
                  src={ic_red_dot}
                  alt={ic_red_dot}
                />
              </TitleDiv>
              <NameInput onChange={name_set} value={name} type="text" />
              <TitleDiv>
                <Content_Text $xbold $xsmall>
                  연락처
                </Content_Text>
                <img
                  style={{ height: 5, marginLeft: 5 }}
                  src={ic_red_dot}
                  alt={ic_red_dot}
                />
              </TitleDiv>
              <div>
                <PhoneInput
                  onChange={phone_f_set}
                  value={phone_f}
                  type="number"
                />
                {" - "}
                <PhoneInput
                  onChange={phone_s_set}
                  value={phone_s}
                  type="number"
                />
                {" - "}
                <PhoneInput
                  onChange={phone_t_set}
                  value={phone_t}
                  type="number"
                />
              </div>
              <TitleDiv>
                <Content_Text $xbold $xsmall>
                  이메일
                </Content_Text>
                <img
                  style={{ height: 5, marginLeft: 5 }}
                  src={ic_red_dot}
                  alt={ic_red_dot}
                />
              </TitleDiv>
              <NameInput onChange={email_set} value={email} type="text" />

              <TitleDiv>
                <Content_Text $xbold $xsmall>
                  프로젝트 예산
                </Content_Text>
              </TitleDiv>
              {/* <PayInput onChange={pay_set} value={pay} type="text" /> */}
              <PayList>
                {pay_list.map((item, index) => {
                  return (
                    <PaySelect key={index}>
                      <CheckBox2
                        type="checkbox"
                        checked={pay === index}
                        onChange={() => {
                          pay_set(index);
                        }}
                      />
                      <Content_Text $xsmall>{item}</Content_Text>
                    </PaySelect>
                  );
                })}
              </PayList>

              <TitleDiv>
                <Content_Text $xbold $xsmall>
                  참고사항
                </Content_Text>
              </TitleDiv>
              <MemoInput onChange={memo_set} value={memo} type="text" />

              <TitleDiv>
                <CheckBox
                  type="checkbox"
                  onClick={() => {
                    set_Check(!check);
                  }}
                />
                <Content_Text $xsmall $bold>
                  개인정보 수집 및 이용 동의
                </Content_Text>
                <Content_Text
                  $xxsmall
                  $lightGray
                  style={{ cursor: "pointer" }}
                  onClick={open_Modal}
                >
                  [자세히보기]
                </Content_Text>
              </TitleDiv>
              <AboutFooter>
                <Button disabled={loading} onClick={send_mail}>
                  신청하기
                </Button>
              </AboutFooter>
            </Main_Content>
          </Main_init_div>
        </Main_div>
      </Main>
      <Footer>
        <Footer_Live />
      </Footer>

      <Privacy_Modal show={modal} onClose={close_Modal} />
    </Container>
  );
}

export default About_Live;
